import type { AreaOfInterest } from "./areaOfInterest.js";

// Define types for the point and polygon vertices
type FlatPolygon = number[];
type NestedPolygon = number[][];

function pointInPolygon(point: number[], vs: FlatPolygon | NestedPolygon, start?: number, end?: number): boolean {
    if (vs.length > 0 && Array.isArray(vs[0])) {
        return pointInPolygonNested(point, vs as NestedPolygon, start, end);
    }
    return pointInPolygonFlat(point, vs as FlatPolygon, start, end);
}

function pointInPolygonFlat(point: number[], vs: FlatPolygon, start?: number, end?: number): boolean {
    const x = point[0];
    const y = point[1];
    let inside = false;
    if (start === undefined) {
        start = 0;
    }
    if (end === undefined) {
        end = vs.length;
    }
    const len = (end - start) / 2;
    for (let i = 0, j = len - 1; i < len; j = i++) {
        const xi = vs[start + i * 2 + 0];
        const yi = vs[start + i * 2 + 1];
        const xj = vs[start + j * 2 + 0];
        const yj = vs[start + j * 2 + 1];
        const intersect = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersect) {
            inside = !inside;
        }
    }
    return inside;
}

function pointInPolygonNested(point: number[], vs: NestedPolygon, start?: number, end?: number): boolean {
    const x = point[0];
    const y = point[1];
    let inside = false;
    if (start === undefined) {
        start = 0;
    }
    if (end === undefined) {
        end = vs.length;
    }
    const len = end - start;
    for (let i = 0, j = len - 1; i < len; j = i++) {
        const xi = vs[i + start][0];
        const yi = vs[i + start][1];
        const xj = vs[j + start][0];
        const yj = vs[j + start][1];
        const intersect = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersect) {
            inside = !inside;
        }
    }
    return inside;
}

export const containsPoint = (aoi: AreaOfInterest, lat: number, long: number): boolean => {
    if (aoi.polygons && aoi.polygons[0]) {
        const transformedBoundaries = aoi.polygons[0].map((p) => [p.lat, p.lng]);
        const point = [lat, long];
        return pointInPolygon(point, transformedBoundaries);
    }
    return false;
};
